import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import { Permission } from 'garaje/utils/ui-permissions';

export default class EmployeeGroupAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;

  // Reads have no dedicated authz permission, so the surface reuses employee-directory read
  // access; the flag keeps it EMNO-only for the M1 rollout.
  get canVisitGlobal(): boolean {
    if (!this.featureFlags.isEnabled('blam-assigned-employee-group')) return false;
    return this.authz.hasPermissionAtCurrentCompany(Permission.USER_MANAGEMENT_EMPLOYEE_READ);
  }
}
